import React from 'react';
import styles from './LoadingSpinner.module.scss';
import { useBrandingContext } from 'app-context/BrandingsContext';

function LoadingSpinner({ showSpinner }) {
  const { brandingData } = useBrandingContext();
  const { page_ButtonColor } = brandingData;
  return (
    <>
      {showSpinner && (
        <div className={styles['loading-overlay']}>
          <div className={styles['spinner']}></div>
        </div>
      )}
    </>
  );
}

export default LoadingSpinner;
